import PageLayout from '@/components/PageLayout';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import styles from '@/styles/Corporate.module.css';
import { useRouter } from 'next/router';
import CorporatePage from '@/components/CorporatePage/CorporatePage';
import { getOrFetchCorporateData, getOrFetchLandings } from '@/utils/corporateCalls';
import { getCmsHomepageLayout, getCorporateContentPageBySlug, getLandingPageBySlug } from '@/api/cms';
import { getLayoutProps } from '@/utils/layout/layout';
import cms, { getCMSDataCsv } from '@/api/config/cms';
import { CustomMetaHead } from '@/components/CustomMetaHead/CustomMetaHead';
import axios from 'axios';
import DefaultProductImage from '../../../public/assets/wave-grocery/Empty-States-Default/DefaultProductImage.png';

export default function CorporateContent({ layoutList, responsiveLogo, extractedArray, dataList, emptyStates }) {
  const router = useRouter();
  const { slug } = router.query;

  const index = extractedArray?.findIndex?.(obj => obj.content.slug === slug[0]);
  const title = extractedArray?.[index]?.content?.title;
  const groupId = extractedArray?.[index]?.content?.groupid;
  const groupTitle = extractedArray?.[index]?.content?.product_group_title;
  const metadata = extractedArray?.[index]?.content?.metadata;
  const csv = extractedArray?.[index]?.content?.product_csv ?? undefined;
  const hasAddAllButtonCTA = extractedArray?.[index]?.content?.hasAddAllButtonCTA ?? false;

  const defaultProdImg = emptyStates?.default_product_image?.url || DefaultProductImage.src;

  const [products, setProducts] = useState();

  useEffect(() => {
    if (csv?.url) {
      getCMSDataCsv(csv.url).then(csvString => {
        setProducts(
          csvString
            .trim()
            .split('\n')
            .map(line => line.trim())
        );
      });
    }
  }, []);

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <CustomMetaHead metadata={metadata} />

      <main className={styles.mainContainer}>
        <div className={styles.corpContainer}>
          <CorporatePage
            layoutList={layoutList[index]}
            dataList={dataList[index]}
            title={title}
            groupId={groupId}
            groupTitle={groupTitle}
            products={products}
            defaultProductImage={defaultProdImg}
            hasAddAllButtonCTA={hasAddAllButtonCTA}
          />
        </div>
      </main>
    </>
  );
}

CorporateContent.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

// TODO: Remove after we conclude we don't need

export async function getStaticPaths({ locales }) {
  // const corporateContent = await getOrFetchLandings();

  // const paths = corporateContent.data.data.map(path => {
  //   return {
  //     params: { slug: [path.content.slug] },
  //   };
  // });

  // const localizedPaths = [];
  // for (const locale of locales) {
  //   for (const path of paths) localizedPaths.push({ ...path, locale });
  // }

  // TODO: Maybe add some important paths
  return { paths: [], fallback: 'blocking' };
}

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, context.locale);

  // const { data: corporateContentData } = await getOrFetchCorporateData('landing_page', context.locale);

  const { data: corporateContentData } = await getLandingPageBySlug(context.params.slug[0], context.locale);
  if (!corporateContentData?.data?.length) {
    return {
      notFound: true,
    };
  }

  const title = corporateContentData;

  const extractedArray = corporateContentData.data;

  const tempList = [];

  for (const array of extractedArray) {
    const temp = array.content.content_component;

    const innerList = [];

    for (const el of temp) {
      if (el?.enabled) {
        const { data: testData } = await getCmsHomepageLayout(el.conten_sub_schema.id, context.locale);
        if (testData.data?.length) innerList.push(testData);
      }
    }

    tempList.push(innerList);
  }

  const layoutList = tempList.map(el => el.map(innerEl => innerEl.data[0].schema));
  const dataList = tempList.map(el =>
    el.map(innerEl => ({ content: innerEl.data[0].content, included: innerEl.included }))
  );
  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    user_history: (await import(`../../../prebuild-data/i18n/${context.locale}/user_history.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      layoutList,
      dataList,
      extractedArray,
      title,
      messages,
      revalidate: 1800,
    },
  };
}
